
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class StandartModalHeader extends Vue {
  @Prop({ type: String, default: "" }) name!: string;
  @Prop({ type: String, default: "" }) id!: string;
}
